import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import DoubleChevron from 'components/icons/double-chevron';
import useLocale from 'helpers/hooks/useLocale';

export const CalendarCustomHeader = ({
  monthDate,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => {
  const { locale } = useLocale();
  console.log('locale', locale);
  return (
    <div className="flex justify-between bg-ag_color-green px-12 py-10">
      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
        <DoubleChevron className="h-16 w-16 rotate-180" />
      </button>
      <span className="react-datepicker__current-month">
        {monthDate.toLocaleString(undefined, {
          month: 'long',
          year: 'numeric',
        })}
      </span>
      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
        <DoubleChevron className="h-16 w-16" />
      </button>
    </div>
  );
};

export default CalendarCustomHeader;
